module.exports = __webpack_public_path__ + "static/media/acorbranches.9047f703.webp";